import { CustomColumnHeader } from 'types';
import { matchesNew } from '@utils/strings';

export const getCustomColumnHeaderIdsOrderMapForLots = (
  customColumnHeaders: CustomColumnHeader[],
  uniqueCustomHeadersList: string[]
): Record<string, number> => {  
  const completeMap: Record<string, number> = {};

  customColumnHeaders.forEach(customHeader => {
    const { id, display_text: displayText } = customHeader;
    const headerIndex = uniqueCustomHeadersList.findIndex(headerText => headerText === displayText);
    
    // If the header is not in the list, we need to add it to the map with its index
    if (!(matchesNew(String(id)) || headerIndex < 0)) completeMap[id] = headerIndex;
  });

  return completeMap;
};
